// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1irOT_M9ofxNJ_AiTNsbO-","text":"_10263WbIzVuWmiDDeVWrfT","icon":"_2OEkiA-WMxl7oiojY0GkTL","rightEl":"_2z3JFWcCMg8MKB638IO0rH","highlighted":"_1XYs-Qmi4RML5wkAT_eWHJ"};